export default __webpack_public_path__ + "static/media/days_out.f32fdb06.svg";